// Meus Links — catálogo de canais e montagem dos links públicos reais.
// Os links são montados com `window.location.origin` + a rota pública real do
// produto + o slug/id do restaurante (checkin_slug), exatamente como os
// próprios produtos fazem (ex.: Reservo/One Menu). Nada é mockado.
import { ATENDABOT_PRODUCT_IMAGE, PRODUCT_IMAGES } from '../../../branding/assets';

// Mantém apenas dígitos (para montar links do WhatsApp).
export const onlyDigits = (value = '') => String(value).replace(/\D/g, '');

// Catálogo dos canais que podem virar link público. Cada item declara:
// - productKey: usado para checar se o restaurante tem o produto habilitado
//   (mesma checagem da tela de Produtos: `hasProductAccess`).
// - build(ctx): monta a URL real a partir de
//   { origin, slug, restaurantId, whatsapp, googleLink }.
//   Se não houver dado suficiente (ex.: sem slug), retorna '' e o canal é ocultado.
export const CHANNELS = [
  {
    id: 'cardapio',
    productKey: 'cardapio',
    name: 'One Menu',
    description: 'Seu cardápio digital',
    icon: PRODUCT_IMAGES.oneMenu,
    backgroundColor: '#fff6f3',
    accent: '#f4a13a',
    build: ({ origin, slug }) => (slug ? `${origin}/cardapio/${slug}` : ''),
  },
  {
    id: 'reservo',
    productKey: 'reservo',
    name: 'Reservo',
    description: 'Reservas de mesa online',
    icon: PRODUCT_IMAGES.reservoIcon,
    backgroundColor: '#ffdb2f',
    accent: '#ffd12f',
    build: ({ origin, slug }) => (slug ? `${origin}/reservar/${slug}` : ''),
  },
  {
    id: 'waitlist',
    productKey: 'reservo',
    name: 'Fila de Espera',
    description: 'Lista de espera do salão',
    icon: null,
    emoji: '⏳',
    accent: '#7c5cff',
    build: ({ origin, slug }) => (slug ? `${origin}/fila/${slug}` : ''),
  },
  {
    id: 'feedback',
    productKey: 'feedback_hero',
    name: 'Feedback Hero',
    description: 'Pesquisa de satisfação',
    icon: PRODUCT_IMAGES.feedbackHero,
    backgroundColor: '#143023',
    accent: '#2ecc71',
    build: ({ origin, slug, googleLink }) =>
      slug
        ? `${origin}/pesquisa?restaurante=${slug}${
            googleLink ? `&gl=${encodeURIComponent(googleLink)}` : ''
          }`
        : '',
  },
  {
    id: 'cv',
    productKey: 'cv',
    name: 'Currículo Certo',
    description: 'Vagas e trabalhe conosco',
    icon: PRODUCT_IMAGES.cv,
    backgroundColor: '#000000',
    accent: '#38bdf8',
    build: ({ origin, slug }) => (slug ? `${origin}/cv/vagas/${slug}` : ''),
  },
  {
    id: 'linkpage',
    productKey: 'linkpage',
    name: 'LinkPage',
    description: 'Sua página de links (bio)',
    icon: PRODUCT_IMAGES.linkPageMark,
    backgroundColor: '#f2f3f3',
    accent: '#111827',
    build: ({ origin, slug }) => (slug ? `${origin}/links/${slug}` : ''),
  },
  {
    id: 'atendabot',
    productKey: 'atendabot',
    name: 'AtendaBot',
    description: 'Atendimento no WhatsApp',
    icon: ATENDABOT_PRODUCT_IMAGE,
    backgroundColor: '#3127A0',
    accent: '#25D366',
    build: ({ whatsapp }) => (whatsapp ? `https://wa.me/${whatsapp}` : ''),
  },
];
